<template>
  <v-dialog v-model="toggle" max-width="500" persistent>
    <v-card
      class="pa-5"
    >
      <v-card-text class="mb-5">
        <h1 class="primary--text pb-5 pt-5">{{ title }}</h1>
        <h3>{{ message }}</h3>
      </v-card-text>

      <v-card-actions>
        <div class="mx-auto">
          <base-button
            x-large
            name="Close"
            @click="toggle = false"
          >
          </base-button>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "BaseErrorDialog",

    props: {
      value: { type: Boolean, default: false },
      title: { type: String, default: '' },
      message: { type: String, default: '' },
    },

    data() {
      return {
        toggle: this.value
      }
    },

    watch: {
      value(val) {
        this.toggle = val;
      },
      toggle(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>